function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import 'reflect-metadata';
import { getMetaMissingFunctionsErrorMsg } from './errorMessages';
var META_KEY_SERVICE = 'service';
export var ServiceMeta =
/*#__PURE__*/
function () {
  function ServiceMeta() {
    _classCallCheck(this, ServiceMeta);

    this.domain = '';
    this.serviceName = '';
    this.methods = [];
    this.events = [];
  }

  _createClass(ServiceMeta, [{
    key: "validate",
    value: function validate(obj) {
      var missingMethods = this.methods.map(function (m) {
        return m.property;
      }).filter(function (f) {
        return typeof obj[f] !== 'function';
      });

      if (missingMethods.length) {
        throw new Error(getMetaMissingFunctionsErrorMsg(this.serviceName, obj.constructor.name, missingMethods));
      }
    }
  }], [{
    key: "get",
    value: function get(target) {
      return Reflect.getMetadata(META_KEY_SERVICE, target);
    }
  }, {
    key: "getOrCreate",
    value: function getOrCreate(target) {
      if (!Reflect.hasMetadata(META_KEY_SERVICE, target)) {
        Reflect.defineMetadata(META_KEY_SERVICE, new ServiceMeta(), target);
      }

      return this.get(target);
    }
  }, {
    key: "getOrThrow",
    value: function getOrThrow(target, error) {
      var result = this.get(target);

      if (!result) {
        var err = typeof error === 'string' ? error : error();
        throw typeof err === 'string' ? new Error(err) : err;
      }

      return result;
    }
  }]);

  return ServiceMeta;
}();
//# sourceMappingURL=ServiceMeta.js.map